var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opening-modal"},[_c('Transition',{attrs:{"name":"slide"}},[(_vm.showLogo)?_c('img',{staticStyle:{"width":"300px"},attrs:{"src":require('@/assets/images/DFCD_logo.svg')}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }